let language = navigator.language.toLowerCase();

if (localStorage.getItem("language")) {
  language = localStorage.getItem("language");
} else {
  language = navigator.language.toLowerCase()
}
const app = {
  state: {
    language: (language === 'zh' || language === 'zh-cn' || language === 'cn') ? 'cn' : 'en'
  },

  mutations: {
    SET_LANGUAGE: (state, language) => {
      state.language = language
    }
  },

  actions: {
    setLanguage({
      commit
    }, language) {
      commit('SET_LANGUAGE', language)
    }
  }
}

export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js